import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import pdfViewerReducer from "../pdf_viewer/slice";

export const store = configureStore({
  reducer: {
    pdfViewer: pdfViewerReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
